import { withStyles } from "@material-ui/core";
import styles from "./styles";
import PopupFieldRenderer from "./common/PopupFieldRenderer";

const DriverAdditionalStopPopup = ({ task, classes }) => {
  return (
    <PopupFieldRenderer
      label={task.stopTypeLabel}
      value={task.arrivalTime}
      labelClassName = {classes.headerLabel}
      valueClassName={classes.headerRowValue}
      rowClassName={classes.additionalStopsRowContainer}
    />
  );
};

export default withStyles(styles)(DriverAdditionalStopPopup);
